import React, { useEffect } from 'react';
import { Row, Col, Form, InputGroup, Card } from "react-bootstrap";
import axiosClient from '../../../../config/axios.js';

function OrderFieldsSuggestedPrice({ values, handleBlur }) {

  const [costoKm, setCostoKm] = React.useState(0);
  const [banderazo, setbanderazo] = React.useState(0);
  const [distancia, setDistancia] = React.useState(0);

  const distanciaKm = async () => {
    const points = values?.order_locations?.map(loc => ({ latitude: loc.latitude, longitude: loc.longitude })) || [];
    try {
      if (points.length < 2) {
        setDistancia(0);
        return;
      }

      const { data } = await axiosClient.post('/calculate-distance', points);
      setDistancia(data?.total || 0);
    } catch (error) {
      console.error("Error calculando distancia:", error);
    }
  };

  useEffect(() => {
    axiosClient.get(`/insurers/${values?.insurance_id.value}`).then(response => {
      const { costo_km, banderazo } = response.data;
      setCostoKm(costo_km);
      setbanderazo(banderazo);
      distanciaKm();
    }).catch(error => {
      console.error('Error fetching insurance data:', error);
    });
  }, [values.insurance_id.value]);

  return (
    <>
      <Row className="mb-3">

        <Form.Group as={Col} md="6" className="d-flex flex-column align-items-left">
          <Form.Label className="me-2 mb-0">Costo por KM</Form.Label>

          <InputGroup className="flex-grow-1 mb-0">
            <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              type="number"
              value={costoKm}
              onBlur={handleBlur}
              disabled={true}
            />
          </InputGroup>
        </Form.Group>

        <Form.Group as={Col} md="6" className="d-flex flex-column align-items-left">
          <Form.Label className="me-2 mb-0">Banderazo</Form.Label>

          <InputGroup className="flex-grow-1 mb-0">
            <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              type="number"
              value={banderazo}
              onBlur={handleBlur}
              disabled={true}
            />
          </InputGroup>
        </Form.Group>

        <Form.Group as={Col} md="6" className="d-flex flex-column align-items-left">
          <Form.Label className="me-2 mb-0">Distancia (KM)</Form.Label>

          <InputGroup className="flex-grow-1 mb-0">
            <Form.Control
              type="number"
              value={distancia}
              onBlur={handleBlur}
              disabled={true}
            />
          </InputGroup>
        </Form.Group>
      </Row>

      <Card className="p-3 mt-3" style={{ backgroundColor: "#d3f3e9" }}>
        <h5 className="d-flex align-items-center m-0">
          💰 Precio sugerido:
          <span className="ms-2">
            Banderazo + (Costo por KM × Distancia) =
          </span>
          <span className="ms-2 fw-bold fs-3">${((banderazo ?? 0) + (costoKm ?? 0) * (distancia ?? 0)).toFixed(2)}</span>
        </h5>
      </Card>
    </>
  );
}

export default OrderFieldsSuggestedPrice;
